import { render, staticRenderFns } from "./SingleInvestment.vue?vue&type=template&id=869abb6e&scoped=true&"
import script from "./SingleInvestment.vue?vue&type=script&lang=js&"
export * from "./SingleInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "869abb6e",
  null
  
)

export default component.exports